<template>
  <div id="sysConst">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" />
    </eb-header>
    <div class="box-header">
      <div class="box-header-right">
        <el-button class="eb-button-red eb-button-small" @click="isSaveDialogShow = true">添加参数</el-button>
        <el-button class="eb-button-red eb-button-small" :disabled="chooseArr.length>1||chooseArr.length==0" @click="removeConst">删除参数</el-button>
        <el-button class="eb-button-red eb-button-small" :disabled="chooseArr.length>1||chooseArr.length==0" @click="isEditDialogShow = true">修改参数</el-button>
      </div>
    </div>
    <div class="table-box">
      <div class="eb-table">
        <el-table :data="tableData" :stripe="true" @selection-change="handleSelectionChange" ref="sysConstRef" style="width: 100%" row-key="key">
          <el-table-column :reserve-selection="true" type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column sortable prop="key" label="键名"></el-table-column>
          <el-table-column sortable prop="value" label="值"></el-table-column>
        </el-table>
      </div>
    </div>
    <eb-pagination class="pagination" :current-page.sync="pageNumber" @current-change="onPagination" :total="pageSize" />
    <saveConstDialog @handleSaveConst="handleSaveConst" :isShow.sync="isSaveDialogShow" />
    <editConstDialog v-if="isEditDialogShow" :chooseData="chooseData" @handleEditConst="handleEditConst" :isShow.sync="isEditDialogShow" />
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import saveConstDialog from '@/components/sys/const/SaveConstDialog';
import editConstDialog from '@/components/sys/const/EditConstDialog';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { saveConst, editConst, delConst, findConstList } from '@/services/const-service';
export default {
  name: 'sysConst',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    saveConstDialog,
    editConstDialog,
    ebPagination
  },
  data() {
    return {
      tableData: [],
      isSaveDialogShow: false,
      isEditDialogShow: false,
      pageNumber: 1,
      pageSize: 0,
      requestParams: {
        number: 10,
        page: 1,
        content: ''
      },
      chooseArr: [],
      chooseData: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    resetRequestParams: function() {
      this.requestParams = {
        number: 10,
        page: 1,
        content: ''
      };
      this.pageSize = 0;
      this.pageNumber = 1;
    },
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await findConstList(this.requestParams);
        if (data.returnCode === '01') {
          this.tableData = data.constList;
          this.pageSize = data.size;
        } else {
          this.$message.error('获取系统参数列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    async removeConst() {
      try {
        let { data } = await delConst(this.chooseData.key);
        if (data.returnCode === '01') {
          this.$message.success('删除系统参数成功');
          this.init();
          this.$nextTick(() => {
            this.$refs.sysConstRef.clearSelection();
          });
        } else if (data.returnCode === '03') {
          this.$message.error('参数不完整');
        } else if (data.returnCode === '04') {
          this.$message.error('您删除系统参数不存在');
        } else {
          this.$message.error('删除系统参数失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    searchData(data) {
      this.requestParams.content = data;
      this.init();
    },
    handleSelectionChange: function(rows) {
      this.chooseArr = rows;
      if (rows && rows.length === 1) {
        this.chooseData = rows[0];
      }
    },
    async handleSaveConst(saveData) {
      try {
        let { data } = await saveConst(saveData.key, saveData.value);
        if (data.returnCode === '01') {
          this.$message.success('添加系统参数成功');
          this.isSaveDialogShow = false;
          this.init();
        } else if (data.returnCode === '03') {
          this.$message.error('参数不完整');
        } else if (data.returnCode === '04') {
          this.$message.error('您添加的系统参数已存在');
        } else {
          this.$message.error('添加系统参数失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async handleEditConst(saveData) {
      try {
        let { data } = await editConst(saveData.key, saveData.value);
        if (data.returnCode === '01') {
          this.$message.success('修改系统参数成功');
          this.isEditDialogShow = false;
          this.init();
        } else if (data.returnCode === '03') {
          this.$message.error('参数不完整');
        } else if (data.returnCode === '04') {
          this.$message.error('您修改系统参数不存在');
        } else {
          this.$message.error('修改系统参数失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    onPagination: function(result) {
      this.requestParams.page = result;
      this.init();
    }
  }
};
</script>
<style lang="less" scoped>
#sysConst {
}
</style>
